import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { AppShell } from './components/layout/AppShell';
// Pages
import { LoginPage } from './pages/auth/LoginPage';
import { RoleRouter } from './pages/auth/RoleRouter';
import { SupplierDashboard } from './pages/supplier/SupplierDashboard';
import { InternalDashboard } from './pages/internal/InternalDashboard';
import { TaskInbox } from './pages/supplier/TaskInbox';
// Full Pages - Supplier
import { CompanyProfile } from './pages/supplier/CompanyProfile';
import { OrdersPage } from './pages/supplier/OrdersPage';
import { InvoicesPage } from './pages/supplier/InvoicesPage';
import { ContractsPage } from './pages/supplier/ContractsPage';
import { OnboardingWorkspace } from './pages/supplier/OnboardingWorkspace';
import { DocumentsPage } from './pages/supplier/DocumentsPage';
import { RiskCompliancePage } from './pages/supplier/RiskCompliancePage';
import { SourcingEventsPage } from './pages/supplier/SourcingEventsPage';
import { ShipmentsPage } from './pages/supplier/ShipmentsPage';
import { PaymentsPage } from './pages/supplier/PaymentsPage';
import { ForecastPage } from './pages/supplier/ForecastPage';
import { QualityPage } from './pages/supplier/QualityPage';
import { MessagesPage } from './pages/supplier/MessagesPage';
import { HelpSupportPage } from './pages/supplier/HelpSupportPage';
import { UserSettingsPage } from './pages/supplier/UserSettingsPage';
// Full Pages - Internal
import { Supplier360Page } from './pages/internal/Supplier360Page';
import { OnboardingCommandPage } from './pages/internal/OnboardingCommandPage';
import { ReviewQueuesPage } from './pages/internal/ReviewQueuesPage';
import { RiskWorkbenchPage } from './pages/internal/RiskWorkbenchPage';
import { ContractConsolePage } from './pages/internal/ContractConsolePage';
import { TransactionMonitorPage } from './pages/internal/TransactionMonitorPage';
import { SupplyCollaborationPage } from './pages/internal/SupplyCollaborationPage';
import { QualityConsolePage } from './pages/internal/QualityConsolePage';
import { CaseConsolePage } from './pages/internal/CaseConsolePage';
import { AdminConfigPage } from './pages/internal/AdminConfigPage';
const ProtectedRoute = ({
  children,
  allowedRole
}: {
  children: React.ReactNode;
  allowedRole?: 'supplier' | 'internal';
}) => {
  const {
    role
  } = useAuth();
  if (!role) return <Navigate to="/login" replace data-id="element-0" />;
  if (allowedRole && role !== allowedRole) return <Navigate to="/role-select" replace data-id="element-1" />;
  return <AppShell data-id="element-2">{children}</AppShell>;
};
export function App() {
  return <AuthProvider data-id="element-3">
      <HashRouter data-id="element-4">
        <Routes data-id="element-5">
          <Route path="/login" element={<LoginPage data-id="element-7" />} data-id="element-6" />
          <Route path="/role-select" element={<RoleRouter data-id="element-9" />} data-id="element-8" />

          {/* Supplier Routes */}
          <Route path="/supplier/dashboard" element={<ProtectedRoute allowedRole="supplier" data-id="element-11">
                <SupplierDashboard data-id="element-12" />
              </ProtectedRoute>} data-id="element-10" />
          <Route path="/supplier/tasks" element={<ProtectedRoute allowedRole="supplier" data-id="element-14">
                <TaskInbox data-id="element-15" />
              </ProtectedRoute>} data-id="element-13" />
          <Route path="/supplier/profile" element={<ProtectedRoute allowedRole="supplier" data-id="element-17">
                <CompanyProfile data-id="element-18" />
              </ProtectedRoute>} data-id="element-16" />
          <Route path="/supplier/onboarding" element={<ProtectedRoute allowedRole="supplier" data-id="element-20">
                <OnboardingWorkspace data-id="element-21" />
              </ProtectedRoute>} data-id="element-19" />
          <Route path="/supplier/documents" element={<ProtectedRoute allowedRole="supplier" data-id="element-23">
                <DocumentsPage data-id="element-24" />
              </ProtectedRoute>} data-id="element-22" />
          <Route path="/supplier/compliance" element={<ProtectedRoute allowedRole="supplier" data-id="element-26">
                <RiskCompliancePage data-id="element-27" />
              </ProtectedRoute>} data-id="element-25" />
          <Route path="/supplier/sourcing" element={<ProtectedRoute allowedRole="supplier" data-id="element-29">
                <SourcingEventsPage data-id="element-30" />
              </ProtectedRoute>} data-id="element-28" />
          <Route path="/supplier/contracts" element={<ProtectedRoute allowedRole="supplier" data-id="element-32">
                <ContractsPage data-id="element-33" />
              </ProtectedRoute>} data-id="element-31" />
          <Route path="/supplier/orders" element={<ProtectedRoute allowedRole="supplier" data-id="element-35">
                <OrdersPage data-id="element-36" />
              </ProtectedRoute>} data-id="element-34" />
          <Route path="/supplier/shipments" element={<ProtectedRoute allowedRole="supplier" data-id="element-38">
                <ShipmentsPage data-id="element-39" />
              </ProtectedRoute>} data-id="element-37" />
          <Route path="/supplier/forecast" element={<ProtectedRoute allowedRole="supplier" data-id="element-41">
                <ForecastPage data-id="element-42" />
              </ProtectedRoute>} data-id="element-40" />
          <Route path="/supplier/quality" element={<ProtectedRoute allowedRole="supplier" data-id="element-44">
                <QualityPage data-id="element-45" />
              </ProtectedRoute>} data-id="element-43" />
          <Route path="/supplier/invoices" element={<ProtectedRoute allowedRole="supplier" data-id="element-47">
                <InvoicesPage data-id="element-48" />
              </ProtectedRoute>} data-id="element-46" />
          <Route path="/supplier/payments" element={<ProtectedRoute allowedRole="supplier" data-id="element-50">
                <PaymentsPage data-id="element-51" />
              </ProtectedRoute>} data-id="element-49" />
          <Route path="/supplier/messages" element={<ProtectedRoute allowedRole="supplier" data-id="element-53">
                <MessagesPage data-id="element-54" />
              </ProtectedRoute>} data-id="element-52" />
          <Route path="/supplier/help" element={<ProtectedRoute allowedRole="supplier" data-id="element-56">
                <HelpSupportPage data-id="element-57" />
              </ProtectedRoute>} data-id="element-55" />
          <Route path="/supplier/settings" element={<ProtectedRoute allowedRole="supplier" data-id="element-59">
                <UserSettingsPage data-id="element-60" />
              </ProtectedRoute>} data-id="element-58" />

          {/* Internal Routes */}
          <Route path="/internal/dashboard" element={<ProtectedRoute allowedRole="internal" data-id="element-62">
                <InternalDashboard data-id="element-63" />
              </ProtectedRoute>} data-id="element-61" />
          <Route path="/internal/suppliers" element={<ProtectedRoute allowedRole="internal" data-id="element-65">
                <Supplier360Page data-id="element-66" />
              </ProtectedRoute>} data-id="element-64" />
          <Route path="/internal/onboarding" element={<ProtectedRoute allowedRole="internal" data-id="element-68">
                <OnboardingCommandPage data-id="element-69" />
              </ProtectedRoute>} data-id="element-67" />
          <Route path="/internal/queues" element={<ProtectedRoute allowedRole="internal" data-id="element-71">
                <ReviewQueuesPage data-id="element-72" />
              </ProtectedRoute>} data-id="element-70" />
          <Route path="/internal/risk" element={<ProtectedRoute allowedRole="internal" data-id="element-74">
                <RiskWorkbenchPage data-id="element-75" />
              </ProtectedRoute>} data-id="element-73" />
          <Route path="/internal/contracts" element={<ProtectedRoute allowedRole="internal" data-id="element-77">
                <ContractConsolePage data-id="element-78" />
              </ProtectedRoute>} data-id="element-76" />
          <Route path="/internal/transactions" element={<ProtectedRoute allowedRole="internal" data-id="element-80">
                <TransactionMonitorPage data-id="element-81" />
              </ProtectedRoute>} data-id="element-79" />
          <Route path="/internal/supply" element={<ProtectedRoute allowedRole="internal" data-id="element-83">
                <SupplyCollaborationPage data-id="element-84" />
              </ProtectedRoute>} data-id="element-82" />
          <Route path="/internal/quality" element={<ProtectedRoute allowedRole="internal" data-id="element-86">
                <QualityConsolePage data-id="element-87" />
              </ProtectedRoute>} data-id="element-85" />
          <Route path="/internal/cases" element={<ProtectedRoute allowedRole="internal" data-id="element-89">
                <CaseConsolePage data-id="element-90" />
              </ProtectedRoute>} data-id="element-88" />
          <Route path="/internal/admin" element={<ProtectedRoute allowedRole="internal" data-id="element-92">
                <AdminConfigPage data-id="element-93" />
              </ProtectedRoute>} data-id="element-91" />

          {/* Default Redirect */}
          <Route path="/" element={<Navigate to="/login" replace data-id="element-95" />} data-id="element-94" />
          <Route path="*" element={<Navigate to="/login" replace data-id="element-97" />} data-id="element-96" />
        </Routes>
      </HashRouter>
    </AuthProvider>;
}